const StatusMap = {
  Novo: { text: "Novo", value: 1 },
  EmAprovação: { text: "Em Aprovação", value: 2 },
  Incompleto: { text: "Incompleto", value: 3 },
  Concluido: { text: "Concluído", value: 4 },
  Manual: { text: "Manual", value: 5 },
  Monitorado: { text: "Monitorado", value: 6 },
  NaoMonitorado: { text: "Não Monitorado", value: 7 },
  NaoPriorizado: { text: "Não Priorizado", value: 8 },
  Excluido: { text: "Excluído", value: 9 },
}

export const getStatusTexFromValue = value => {
  const status = Object.values(StatusMap).find(item => item.value === value)
  return status ? status.text : ""
}

export default StatusMap
